export class MenuConfig {

	isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	public defaults: any = {
		header: {
			self: {},
			items: [
				{
					title: 'Dashboards',
					root: true,
					alignment: 'left',
					page: '/dashboard',
					translate: 'MENU.DASHBOARD',
				},

			]
		},
		aside: {
			self: {},
			items: [
				{
					title: 'Dashboard',
					root: true,
					icon: 'home',
					page: '/dashboard/dashboard',
					translate: 'MENU.DASHBOARD',
					bullet: 'dot',
				},

				/**
				 * Applications
				 * @author Rosa Korse
				 * @since 2019-11-19
				 */

				{ section: 'Applications' },

				{
					title: 'O2C',
					root: true,
					icon: 'attach_money',
					class: 'o2c',
					submenu: [
						// {
						//     title: 'Maintenance',

						// },
						{
							title: 'Administration',
							faIcon: 'fas fa-list',
							submenu: [
								{
									title: 'Invoices',
									submenu: [
										{
											title: 'Add Support Docs.',
											page: '/o2c/admin/invoicesAddDoc'
										},
										{
											title: 'View Support Docs.',
											page: '/o2c/admin/invoicesViewDoc'
										}
									]
								},
								{
									title: 'EDI',
									submenu: [
										{
											title: 'EDI Addresses Information',
											page: '/o2c/admin/customerAddresses'
										},
										{
											title: 'Discrepancy Types',
											page: '/o2c/admin/discrepancyTypes'
										},
										{
											title: 'Master Codes',
											page: '/o2c/admin/masterCodes'
										},
										{
											title: 'Inbound Control',
											page: '/o2c/admin/inboundControl'
										},
										{
											title: 'Product Mapping',
											page: '/o2c/admin/productMapping'
										},

										{
											title: 'Structure Integration',
											page: '/o2c/admin/providerIntegarions'
										},
										{
											title: 'Error Message Mapping',
											page: '/o2c/admin/errorMessageMapping'
										},
										{
											title: 'Customer Mapping',
											page: '/o2c/admin/customerMapping'
										}
									]
								},
								{
									title: 'Customer Statement',
									submenu: [
										{
											title: 'Change Email Message',
											page: '/o2c/admin/changeEmailMessage'
										}
									]
								},
								{
									title: 'Confirmation Passing',
									submenu: [
										{
											title: 'Sales Orders Passing',
											page: '/o2c/admin/salesOrdersPassing'
										}
									]
								},
								{
									title: 'Agent Configuration Panel',
									submenu: [
										{
											title: 'Agent Settings Types',
											page: '/o2c/admin/agentSettingsTypes'
										},
										{
											title: 'Agent Settings Fields',
											page: '/o2c/admin/agentSettingsFields'
										},
										{
											title: 'Agent Settings Profiles',
											page: '/o2c/admin/agentSettingsProfiles'
										}
									]
								}
							]
						},
						{
							title: 'Processing',
							faIcon: 'fas fa-cogs',
							submenu: [
								{
									title: 'Invoicing',
									page: '/o2c/processing/unprocessed'
								},
								{
									title: 'Debits and Credits',
									page: '/o2c/processing/debitsCredits'
								},
								{
									title: 'Support Credit Documents',
									page: '/o2c/processing/supportCreditDoc'
								},
								{
									title: 'EDI Order Management',
									submenu: [
										{
											title: 'EDI Transaction Management',
											page: '/o2c/processing/purchaseOrders'
										},
										{
											title: 'Create New Sales Order',
											page: '/o2c/processing/createSalesOrder'
										}
										,
										
										{
											title: 'Modify Sales Order',
											page: '/o2c/processing/updateSalesOrder'
										},
										{
											title: 'Cancel PO / Sales Order',
											page: '/o2c/processing/cancelSalesOrder'
										},
										{
											title: 'Change/Assign PO Number',
											page: '/o2c/processing/changeSalesOrder'
										}
									]
								},
								{
									title: 'Create Sales Order for No EDI Orders',
									page: '/o2c/processing/noEDIOrdersList'
								},

							]
						},
						{
							title: 'Inquiries',
							faIcon: 'fas fa-check-square',
							submenu: [
								{
									title: 'Invoice Search',
									page: '/o2c/inquiries/invoice',
								},
								{
									title: 'Document Logs',
									page: '/o2c/inquiries/log'
								},
								{
									title: 'Customer Statement',
									page: '/o2c/inquiries/customerStatement'
								},
								{
									title: 'EDI PO Search',
									page: '/o2c/inquiries/ediPoSearch'
								},
								{
									title: 'EDI PO Detail Report',
									page: '/o2c/inquiries/ediPoDetailReport'
								},
								{
									title: 'EDI Message Search',
									page: '/o2c/inquiries/messageSearch'
								},
								{
									title: 'EDI Discrepancy Summary',
									page: '/o2c/inquiries/discrepancyReport'
								},
								{
									title: 'Sales Order Search',
									page: '/o2c/inquiries/saleOrderSearchO2C'
								},
								{
									title: 'Sales Inventory Dist Report',
									page: '/o2c/inquiries/salesInventoryDistReport'
								}
							]
						},
					]
				},
				{
					title: 'Operations',
					root: true,
					icon: 'directions_boat',
					class: 'operations',
					submenu: [
						// {
						//     title: 'Maintenance',

						// },
						{
							title: 'Administration',
							faIcon: 'fas fa-list',
							submenu: [
								{
									title: 'Harmonized Tariff',
									page: '/operations/admin/harmonizedTariff'
								},
								{
									title: 'Warehouse Contacts',
									page: '/operations/admin/warehouseContacts'
								},
								{
									title: 'COS Attributes ',
									page: '/operations/admin/cosAttributes'
								},
								{
									title: 'Warehouse Controls',
									page: '/operations/admin/warehouseControls'
								},
								{
									title: 'Warehouse Doors',
									page: '/operations/admin/warehouseDoors'
								}
							]
						},
						{
							title: 'Processing',
							faIcon: 'fas fa-cogs',
							submenu: [
								{
									title: 'Truck Receipt',
									page: '/operations/processing/truckReceipt',
								},
								{
									title: 'Confirmation Of Sales',
									page: '/operations/processing/confirmationOfSales',
								},
								{
									title: 'Warehouse Processing',
									submenu: [
										{
											title: 'IN/OUT Planning',
											page: '/operations/processing/assignWHLocation',
										},
										{
											title: 'Assign Dock Number',
											page: '/operations/processing/assignDoor',
										},
										{
											title: 'Inbound Inspection',
											page: '/operations/processing/inInspection',
										},
										!this.isMobile ? {
											title: 'Receive Shipment',
											page: '/operations/processing/receiveShipment',
										}:{
											title: 'Receive Shipment',
											page: '/operations/processing/receiveSelection',
										} ,
										{
											title: 'Outbound Inspection',
											page: '/operations/processing/outInspection',
										},
										{
											title: 'Ship Order',
											page: '/operations/processing/shipOrder',
										}
									]
								},

							]
						},
						{
							title: 'Inquiries',
							faIcon: 'fas fa-check-square',
							submenu: this.isMobile ? [
								{
									title: 'Out Turn',
									page: '/operations/inquiries/outTurn',
								},
								{
									title: 'Container Inquiries',
									submenu: [
										{
											title: 'Container Report',
											page: '/operations/inquiries/containerReport',
										},
										{
											title: 'Container Search',
											page: '/operations/inquiries/containerSearch',
										},
										{
											title: 'Pallet / Container Search',
											page: '/operations/inquiries/palletContainerSearch',
										},
										{
											title: 'Pallet Scan',
											page: '/operations/inquiries/palletScan',
										},
									]
								},
								{
									title: 'Warehouse Inquiries',
									submenu: [
										{
											title: 'Warehouse Daily Report',
											page: '/operations/inquiries/warehouseDaily',
										},
										{
											title: 'Warehouse Container Search',
											page: '/operations/inquiries/warehouseInventory',
										},
										{
											title: 'Warehouse Inventory Search',
											page: '/operations/inquiries/warehouseInventorySearch',
										},
										{
											title: 'IN/OUT Inspection Report',
											page: '/operations/inquiries/inspectionReport',
										}
									]
								},
								{
									title: 'Trucker Contacts',
									page: '/operations/inquiries/truckerContacts',
								},
								{
									title: 'Order Releases Report',
									page: '/operations/inquiries/orderReleasesReport',
								},
								{
									title: 'Warehouse Inventory',
									page: '/operations/inquiries/warehouseInventoryReport',
								},

								{
									title: 'Sales Order Search',
									page: '/operations/inquiries/saleOrderSearchOperations',
								}


							] :
								[
									{
										title: 'Out Turn',
										page: '/operations/inquiries/outTurn',
									},
									{
										title: 'Container Inquiries',
										submenu: [
											{
												title: 'Container Report',
												page: '/operations/inquiries/containerReport',
											},
											{
												title: 'Container Search',
												page: '/operations/inquiries/containerSearch',
											},
											{
												title: 'Pallet / Container Search',
												page: '/operations/inquiries/palletContainerSearch',
											},{
												title: 'Container Stripping Times',
												page: '/operations/inquiries/containerStripping',
											}

										]
									}
									,

									{
										title: 'Order Releases Report',
										page: '/operations/inquiries/orderReleasesReport',
									},

									{
										title: 'Sales Order Search',
										page: '/operations/inquiries/saleOrderSearchOperations'
									},
									{
										title: 'Warehouse Inquiries',
										submenu: [
											{
												title: 'Warehouse Daily Report',
												page: '/operations/inquiries/warehouseDaily',
											},
											{
												title: 'Warehouse Container Search',
												page: '/operations/inquiries/warehouseInventory',
											},
											{
												title: 'Warehouse Inventory Details',
												page: '/operations/inquiries/warehouseInventorySearch',
											},
											{
												title: 'IN/OUT Inspection Report',
												page: '/operations/inquiries/inspectionReport',
											},
											{
												title: 'Warehouse Inventory',
												page: '/operations/inquiries/warehouseInventoryReport',
											}

										]
									},
									{
										title: 'Trucker Contacts',
										page: '/operations/inquiries/truckerContacts',
									}

								]
						}
					]
				},

				{
					title: 'Supply Chain',
					root: true,
					faIcon: 'fas fa-link',
					class: 'supply',
					submenu: [
						{
							title: 'Administration',
							root: true,
							faIcon: 'fas fa-list',
							submenu: [
								{
									title: 'Schedule',
									page: '/supplyChain/admin/schedule'
								},
								{
									title: 'Vessels',
									page: '/supplyChain/admin/vessels'
								},
								{
									title: 'Loading Ports',
									page: '/supplyChain/admin/loadingPorts'
								}
							]

						},

						{
							title: 'Processing',
							root: true,
							faIcon: 'fas fa-cogs',
							submenu: [
								{
									title: 'Prebooks / Plans',
									page: '/supplyChain/processing/prebooksPlans'
								},
								{
									title: 'Order Consolidation',
									page: '/supplyChain/processing/orderConsolidation'
								},
								 {
									title: '7 Weeks Rolling Forecast Vendors',
									page: '/supplyChain/processing/5WRV'
								}
							]
						},
						{
							title: 'Inquiries',
							root: true,
							faIcon: 'fas fa-check-square',
							submenu: [
								{
									title: 'Prebooks',
									page: '/supplyChain/inquiries/prebooks'
								},
								{
									title: 'Orders',
									page: '/supplyChain/inquiries/orders'
								},
								{
									title: 'Sales Vs. Prebooks',
									page: '/supplyChain/inquiries/salesVsPrebooks'
								},

								// {
								//     title: '5 Weeks Rolling Forecast Shipping lines',
								//     page: '/supplyChain/inquiries/5WRF'
								// },

								// {
								//     title: 'Financial Forecasting',
								//     page: '/supplyChain/inquiries/financialForecasting'
								// },
								// {
								//     title: 'Mid Term Planning',
								//     page: '/supplyChain/inquiries/MTP'
								// }
							]
						},


					]
				},
				{
					title: 'C&C',
					root: true,
					faIcon: 'fa fa-edit',
					class: 'cnc',
					submenu: [
						{
							title: 'Administration',
							faIcon: 'fas fa-list',
							submenu: [
								{
									title: 'Complaints',
									submenu: [
										{
											title: 'Master Menu',
											submenu: [
												{
													title: 'Complaint Reasons',
													page: '/cnc/admin/complaintReasons'
												},
												{
													title: 'Complaint Subreasons',
													page: '/cnc/admin/complaintSubreasons'
												},
												{
													title: 'Complaint Types',
													page: '/cnc/admin/complaintTypes'
												},
												{
													title: 'Boxes',
													submenu: [
														{
															title: '  Units of Boxes Affected',
															page: '/cnc/admin/boxesAffected'
														},
														{
															title: '  Clusters per Box',
															page: '/cnc/admin/clustersPerBox'
														}
													]
												}
												,
												{
													title: 'Disposition',
													page: '/cnc/admin/disposition'
												},
												{
													title: 'Non-Claimable Subreasons',
													page: '/cnc/admin/nonClaimableSubreasons'
												},
												{
													title: 'Credit-Note Charge Types',
													page: '/cnc/admin/chargeTypes'
												}
												
											]
										},
										{
											title: 'Workflow Process',
											submenu: [
												{
													title: 'Status Codes',
													page: '/cnc/admin/statusCodes'
												}
												,
												{
													title: 'Processes',
													page: '/cnc/admin/processes'
												}
												,
												{
													title: 'Notify Parties',
													page: '/cnc/admin/notifyParties'
												},
												{
													title: 'WorkFlows',
													page: '/cnc/admin/workFlows'
												}
											]
										},
										{
											title: 'Associations',
											submenu: [
												{
													title: 'Reasons to Subreasons',
													page: '/cnc/admin/complaintReasonSubreason'
												},
												{
													title: 'Reasons to Types',
													page: '/cnc/admin/complaintReasonType'
												},
												{
													title: 'Reasons to Disposition',
													page: '/cnc/admin/complaintReasonDisposition'
												}
											]
										}
									]
								},
								{
									title: 'Claims',
									submenu: [
										{
											title: 'Master Menu',
											submenu: [
												{
													title: 'Claim Reasons',
													page: '/cnc/admin/claimReasons'
												},
												{
													title: 'Vendors',
													page: '/cnc/admin/vendorEmails'
												},
												{
													title: 'Notification Format',
													page: '/cnc/admin/notificationFormat'
												}
											]
										},
										{
											title: 'Workflow Process',
											submenu: [
												{
													title: 'Status Codes',
													page: '/cnc/admin/statusCodeClaims'
												},
												{
													title: 'Processes',
													page: '/cnc/admin/processClaims'
												},
												{
													title: 'Notify Parties',
													page: '/cnc/admin/notifyPartyClaims'
												},
												{
													title: 'WorkFlows',
													page: '/cnc/admin/workFlowClaims'
												}
											]
										}
									]
								}
							]
						},
						{
							title: 'Processing',
							root: true,
							faIcon: 'fas fa-cogs',
							submenu: [
								{
									title: 'Complaints',
									submenu: [
										{
											title: 'Create/Edit Complaints',
											page: '/cnc/processing/createEditComplaints'
										},
										{
											title: 'ToDo',
											page: '/cnc/processing/toDos'
										},
										{
											title: 'ToDo Delegation',
											page: '/cnc/processing/toDoDelegation'
										},
										{
											title: 'Confirmation Add On',
											page: '/cnc/processing/confirmationAddOn'
										}
									]
								},
								{
									title: 'Claims',
									submenu: [
										{
											title: 'Create/Edit Claims',
											page: '/cnc/processing/createLon'
										}
									]
								}
							]
						},
						{
							title: 'Inquiries',
							root: true,
							faIcon: 'fas fa-check-square',
							submenu: [
								{
									title: 'Complaints',
									submenu: [
										{
											title: 'Complaints Search',
											page: '/cnc/inquiries/searchComplaints'
										},
										{
											title: 'Complaint Details',
											page: '/cnc/inquiries/detailsComplaints'
										},
										{
											title: 'Complaint Overview Report',
											page: '/cnc/inquiries/complaintOverviewReport'
										},
										{
											title: 'Customer Open Complaints',
											page: '/cnc/inquiries/customerOpenComplaints'
										},
										{
											title: 'ToDos Report',
											page: '/cnc/inquiries/toDosReport'
										}
									]
								},
								{
									title: 'Claims',
									submenu: [
										{
											title: 'Claim Search',
											page: '/cnc/inquiries/searchLons'
										},
										{
											title: 'Claim Details',
											page: '/cnc/inquiries/claimDetailsReport'
										}
									]
								}
							]
						}

					]
			},
				{
					title: 'Analytics',
					root: true,
					faIcon: 'far fa-chart-bar',
					submenu:  [
						{
							title: 'Administration',
							faIcon: 'fas fa-list',
							submenu: [
								{
									title: 'QC Daily Report Settings',
									page: '/analytics/admin/qcDailyReportSettings',
								}
							]
						},
					],
				},
				{
					title: 'Community Apps',
					root: true,
					faIcon: 'fas fa-users',
					class: 'communityApps',
					submenu: [
						{
							title: 'Mobile App',
							page: '/communityApps/mobileApp'
						},
						{
							title: 'FyffesPedia',
							page: '/communityApps/chatgpt'
						}
					]
				},
				{
					title: 'Settings',
					root: true,
					icon: 'settings',
					class: 'a2a',
					submenu: [
						{
							title: 'A&A',					
							icon: 'account_circle',
							class: 'a2a',
							submenu: [
								{
									title: 'Master Data',
									faIcon: 'fas fa-list',
									submenu: [
										{
											title: 'Application - Components',
											page: '/ana/masterData/applications'
										},
										{
											title: 'Roles - Profiles',
											page: '/ana/masterData/rolesProfiles'
										},
										{
											title: 'Entity Types',
											page: '/ana/masterData/entityTypes'
										}
										
									]
								},
								{
									title: 'Associations',
									faIcon: 'fas fa-cogs',
									submenu: [
										{
											title: 'Application to Entity Types',
											page: '/ana/associations/appEntityTypes'
										},
										{
											title: 'Profiles to Components',
											page: '/ana/associations/profilesComponents'
										},
										{
											title: 'User to Entities',
											page: '/ana/associations/userEntities'
										},
										{
											title: 'User to Roles',
											page: '/ana/associations/userRoles'
										}
									]
								},
								{
									title: 'Inquiries',
									faIcon: 'fas fa-check-square',
									submenu: [
										{
											title: 'By User',
											page: '/ana/inquiries/userInquiry'
										},
										{
											title: 'Users by Component',
											page: '/ana/inquiries/userComponents'
										},
										{
											title: 'Entities',
											page: '/ana/inquiries/entities'
										}
									]
								}
							]
						},
						{
							title: 'System Parameters',					
							icon: 'settings_applications',
							class: 'a2a',
							submenu: [
								{
									title: 'Master Data',
									faIcon: 'fas fa-list',
									submenu: [									
										{
											title: 'Parameters',
											page: '/ana/masterData/parametersTypes'
										}
									]
								},
								{
									title: 'Associations',
									faIcon: 'fas fa-cogs',
									submenu: [
										
									]
								},
								{
									title: 'Inquiries',
									faIcon: 'fas fa-check-square',
									submenu: [
										
									]
								}
							]
						}
						
				
					]
				},

			]
		},
	};

	public get configs(): any {
		return this.defaults;
	}
}
